import { render, staticRenderFns } from "./AttributeCheckbox.vue?vue&type=template&id=478a6e98&"
import script from "./AttributeCheckbox.vue?vue&type=script&lang=js&"
export * from "./AttributeCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AttributeCheckbox.vue?vue&type=style&index=0&id=478a6e98&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports